
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import AreaHero from '../components/AreaHero';
import AreaServices from '../components/AreaServices';
import AreaTestimonials from '../components/AreaTestimonials';
import AreaCTA from '../components/AreaCTA';
import { useSEO, generateWebPageSchema, generateBreadcrumbSchema } from '../../../utils/seo';

export default function WatfordPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://brushour.co.uk';

  useSEO({
    title: 'Painters & Decorators Watford | Oxhey, Garston, Holywell | Brushour',
    description: 'Professional painters and decorators serving Watford, Oxhey, Garston, Holywell, Carpenders Park, Nascot Wood, Leggatts, and Callowland. Trusted local decorating experts in Watford, Hertfordshire. Free quotes available.',
    keywords: 'painters Watford, decorators Watford Hertfordshire, painting Oxhey, decorating Garston, painters Holywell, Carpenders Park decorators, Nascot Wood painters, painting services Watford',
    canonical: `${SITE_URL}/areas/watford`,
    schema: [
      generateWebPageSchema(
        'Painters & Decorators Watford – Oxhey, Garston, Holywell & More',
        'Professional painting and decorating services across Watford neighbourhoods including Oxhey, Garston, Holywell, Carpenders Park, Nascot Wood, Leggatts, and Callowland.',
        `${SITE_URL}/areas/watford`
      ),
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'Brushour – Painters & Decorators Watford',
        description: 'Expert painting and decorating services in Watford and its neighbourhoods: Oxhey, Garston, Holywell, Carpenders Park, Nascot Wood, Leggatts, and Callowland.',
        url: `${SITE_URL}/areas/watford`,
        telephone: '+447595037441',
        email: 'daniel@brushour.co.uk',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Watford',
          addressRegion: 'Hertfordshire',
          postalCode: 'WD17',
          addressCountry: 'GB',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 51.6565,
          longitude: -0.3903,
        },
        priceRange: '££',
        areaServed: [
          { '@type': 'Place', name: 'Watford Town Centre' },
          { '@type': 'Place', name: 'Oxhey' },
          { '@type': 'Place', name: 'Garston' },
          { '@type': 'Place', name: 'Holywell' },
          { '@type': 'Place', name: 'Carpenders Park' },
          { '@type': 'Place', name: 'Nascot Wood' },
          { '@type': 'Place', name: 'Leggatts' },
          { '@type': 'Place', name: 'Callowland' },
        ],
      },
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Areas', url: `${SITE_URL}/areas` },
        { name: 'Watford', url: `${SITE_URL}/areas/watford` },
      ]),
    ],
  });

  const areaData = {
    name: 'Watford',
    region: 'Hertfordshire',
    description: 'Expert painting and decorating services in Watford. From residential properties to commercial spaces, we deliver exceptional results with attention to detail and professional craftsmanship throughout Watford and surrounding areas.',
    heroImage: 'https://public.readdy.ai/ai/img_res/4360e807106c438f6bdd6f5d8729a860.jpg',
    serviceAreas: ['Watford Town Centre', 'Oxhey', 'Carpenders Park', 'Garston', 'Holywell', 'Nascot Wood', 'Leggatts', 'Callowland'],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AreaHero data={areaData} />
      <AreaServices area="Watford" />
      <AreaTestimonials area="Watford" />
      <AreaCTA area="Watford" />
      <Footer />
    </div>
  );
}
